import { Skeleton } from 'antd';
import { NftAvatarBlockSkeleton } from 'components/Shared/NftAvatarBlock/Skeleton';
import { NftPropertiesHistorySkeleton } from 'components/Shared/NftPropertiesHistory/Skeleton';
import { NftPurchaseBlockSkeleton } from 'components/Shared/NftPurchaseBlock/Skeleton';
import * as Styled from './styles';
import { LeftArrow } from 'icons/LeftArrow';

export const NftViewMobileSkeleton = () => {
  return (
    <div style={{ overflow: 'auto', height: '100%' }}>
      <Styled.OwnerBox>
        <Styled.ArrowBox>
          <LeftArrow />
        </Styled.ArrowBox>
        <Skeleton.Button
          active
          style={{
            borderRadius: 12,
            height: '44px',
            width: '108px'
          }}
        />
      </Styled.OwnerBox>
      <Styled.Wrapper>
        <Styled.NftMediaSkeleton />
        <Styled.AvatarsWrapper>
          <NftAvatarBlockSkeleton size="large" />
          <NftAvatarBlockSkeleton size="large" />
        </Styled.AvatarsWrapper>
        <Styled.NftTitle>
          <Skeleton.Button
            block
            active
            style={{
              height: '32px',
              width: '80%',
              margin: '2 0'
            }}
          />
        </Styled.NftTitle>
        <NftPurchaseBlockSkeleton />
        <NftPropertiesHistorySkeleton />
        <Styled.BlankSpace />
      </Styled.Wrapper>
    </div>
  );
};
